var _style, _g, _g2, _g3, _g4, _g5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuiGonLogo2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0qg{fill:#588443;}\r\n\t.st1qg{fill:#82645A;}\r\n\t.st2qg{fill:#FAC8AA;}\r\n\t.st3qg{fill:#F9C2A0;}\r\n\t.st4qg{fill:#755548;}\r\n\t.st5qg{fill:#825716;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lag_1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0qg",
    cx: 150,
    cy: 150.3,
    r: 150
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Lag_6"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Lag_5"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Lag_2"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Lag_4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1qg",
    d: "M59.8,170c-5.1,26.5-10.2,52.9-15.2,79.4c71.4,0,142.9-0.1,214.3-0.1c-3.9-25.9-7.9-51.9-11.8-77.8 C184.6,170.9,122.2,170.4,59.8,170z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2qg",
    d: "M91.9,58.2c-11,24.7-22,49.4-33,74.1c-2,7.1-7.4,29.5,4.7,43.2c0.9,1,1.9,2,3.1,3c2.7,0.7,5.5,1.4,8.2,2.2 c1,8.2,4.1,24.2,15.7,39.5c2.1,2.8,25,32,62.9,32.2V55.8C132.9,56.6,112.4,57.4,91.9,58.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3qg",
    d: "M246.1,131.4c-12.7-26-25.4-51.9-38.2-77.9c-18.5,0.7-37,1.5-55.5,2.2v196.7c1.7,0,3.4,0,5.2-0.1 c34.3-2.2,54-26.9,57.1-30.9c3.5-4.5,7.8-11.1,11.3-19.6c3-7.5,4.5-14.2,5.2-19.5c3.9-0.6,6.6-1.9,8.6-3.3 C250.4,171.5,252.8,152.4,246.1,131.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1qg",
    d: "M58.7,132.3c7.9,5.2,15.8,10.4,23.7,15.7c0.1-15.9,0.2-31.8,0.3-47.7c5-13,9.9-25.9,14.9-38.9 c7.4,4.9,28,17.1,56.9,16.7c27-0.4,46.3-11.7,53.7-16.7c5.2,12.9,10.4,25.7,15.6,38.6c0.2,15.8,0.3,31.7,0.5,47.5 c7.9-5,15.8-9.9,23.7-14.9C253,69.2,200.6,19,146.9,22.5C97.3,25.7,53.9,74.2,58.7,132.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4qg",
    d: "M82.5,178.6c14.1,19.5,28.2,39,42.3,58.4c17.6,0,35.2,0,52.8,0c14.2-18.4,28.4-36.8,42.6-55.2 c2.1,0.5,4.9,0.9,8.2,0.8c2.8-0.1,5.3-0.6,7.1-1.1c-1.3,8.8-4.8,24.5-16.2,39.9C205,241,180.6,256.5,155,256.9 c-37.3,0.6-74.5-30.8-84.8-77.4c1.4,0.4,3.5,0.8,6.1,0.7C79,180,81.2,179.2,82.5,178.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4qg",
    d: "M109.9,208.3c-0.9-2.3,9.2-9,18-12.5c7.6-3,14.4-3.9,19-4.1c-0.8,3.7-1.6,7.3-2.3,11 C117.3,210,110.6,210,109.9,208.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4qg",
    d: "M195.1,208.2c0.9-2.3-9.2-9-18-12.5c-7.6-3-14.4-3.9-19-4.1c0.8,3.7,1.6,7.3,2.3,11 C187.8,209.9,194.5,209.8,195.1,208.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4qg",
    d: "M143.5,220c-0.6,6.1,4.4,11.2,9.7,11c5-0.2,9.5-5.1,8.9-11C155.8,220,149.7,220,143.5,220z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st5qg",
    d: "M67.7,184.8"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuiGonLogo2);
export default __webpack_public_path__ + "static/media/qui-gon-logo2.52315b65.svg";
export { ForwardRef as ReactComponent };